import { render, staticRenderFns } from "./DeviceScreenLink.vue?vue&type=template&id=21ee6ab1"
import script from "./DeviceScreenLink.vue?vue&type=script&lang=ts"
export * from "./DeviceScreenLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports